(function () {
  var tbody = document.getElementById('mod-body');
  var formSel = document.getElementById('f-formation');
  if (!tbody && !formSel) return; // this page doesn't include the Passerelle home section

  var MODES = [
    { fr: "Cours de français", ar: "اللغة الفرنسية", pc: true, pa: true, d: true },
    { fr: "Cours d'anglais", ar: "اللغة الإنجليزية", pc: true, pa: true, d: true },
    { fr: "Passerelle Junior", ar: "باسيريل جونيور", pc: true, pa: false, d: false },    { fr: "Certifications TCF · DELF · DALF", ar: "التحضير للشهادات", pc: true, pa: true, d: true },
    { fr: "Certifications TCF · DELF · DALF", ar: "التحضير للشهادات", pc: true, pa: true, d: true }, { fr: "Soutien scolaire", ar: "الدعم المدرسي", pc: true, pa: false, d: false },
    { fr: "Soutien scolaire", ar: "الدعم المدرسي", pc: true, pa: false, d: false }, { fr: "Soutien CNED", ar: "الدعم عن بعد (CNED)", pc: true, pa: false, d: false },
    { fr: "Informatique & bureautique", ar: "الإعلام الآلي والمكتبية", pc: true, pa: true, d: false },
  ];

  if (tbody) {
    var yes = '<span class="dot-mark yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
    var no = '<span class="dot-mark no"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span>';
    tbody.innerHTML = MODES.map(function (m) {
      return '\n    <tr>\n      <td class="name">' + m.fr + '<span class="ar">' + m.ar + '</span></td>\n      <td>' + (m.pc ? yes : no) + '</td>\n      <td>' + (m.pa ? yes : no) + '</td>\n      <td>' + (m.d ? yes : no) + '</td>\n    </tr>\n  ';
    }).join('');
  }

  // ---------- inscription form ----------
  var modaliteSel = document.getElementById('f-modalite');
  if (!formSel || !modaliteSel) return; // inscription form not present on this page

  var MODALITE_LABELS = {
    pc: { fr: 'Présentiel continu', ar: 'حضوري مستمر' },
    pa: { fr: 'Présentiel accéléré (vacances scolaires)', ar: 'حضوري مكثف (فترة العطل)' },
    d: { fr: 'Distanciel continu', ar: 'عن بعد مستمر' },
  };
  MODES.forEach(function (m, i) {
    var opt = document.createElement('option');
    opt.value = i;
    opt.textContent = m.fr + ' — ' + m.ar;
    formSel.appendChild(opt);
  });
  function refreshModalites() {
    var m = MODES[formSel.value];
    modaliteSel.innerHTML = '';
    ['pc', 'pa', 'd'].forEach(function (key) {
      if (m[key]) {
        var opt = document.createElement('option');
        opt.value = key;
        opt.textContent = MODALITE_LABELS[key].fr + ' — ' + MODALITE_LABELS[key].ar;
        modaliteSel.appendChild(opt);
      }
    });
  }
  formSel.addEventListener('change', refreshModalites);
  refreshModalites();

  function buildInscriptionMessage() {
    var nom = document.getElementById('f-nom').value.trim();
    var tel = document.getElementById('f-tel').value.trim();
    var email = document.getElementById('f-email').value.trim();
    var formation = MODES[formSel.value];
    var modalite = MODALITE_LABELS[modaliteSel.value];
    var msg = document.getElementById('f-msg').value.trim();
    return [
      'Nom complet : ' + nom,
      'Téléphone : ' + tel,
      email ? 'Email : ' + email : null,
      'Formation souhaitée : ' + formation.fr,
      'Modalité souhaitée : ' + modalite.fr,
      msg ? 'Message : ' + msg : null,
    ].filter(Boolean).join('\n');
  }

  var CONTACT = window.PASSERELLE_CONTACT || {};
  var CONTACT_EMAIL = CONTACT.email || 'contact@lapasserelle-academy.com';
  var CONTACT_WHATSAPP = CONTACT.whatsapp || '213557451592';

  var sendEmailBtn = document.getElementById('sendEmail');
  var sendWhatsBtn = document.getElementById('sendWhats');

  if (sendEmailBtn) {
    sendEmailBtn.addEventListener('click', function () {
      var form = document.getElementById('inscForm');
      if (!form.reportValidity()) return;
      var subject = "Demande d'inscription — La Passerelle Academy";
      var url = 'mailto:' + CONTACT_EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(buildInscriptionMessage());
      window.location.href = url;
    });
  }

  if (sendWhatsBtn) {
    sendWhatsBtn.addEventListener('click', function () {
      var form = document.getElementById('inscForm');
      if (!form.reportValidity()) return;
      var body = "Bonjour, je souhaite m'inscrire :\n" + buildInscriptionMessage();
      window.open('https://wa.me/' + CONTACT_WHATSAPP + '?text=' + encodeURIComponent(body), '_blank');
    });
  }
})();

// ---------- soutien scolaire : catalogue niveau > classe > matière > professeur ----------
(function () {
  var tabsEl = document.getElementById('lvlTabs');
  var crumbEl = document.getElementById('soutienCrumb');
  var panelEl = document.getElementById('soutienPanel');
  if (!tabsEl || !crumbEl || !panelEl) return; // section absente de cette page

  var CATALOG = window.SOUTIEN_CATALOG || { levels: [], teachers: [] };
  var TARIFS = window.SOUTIEN_TARIFS || { oneSession: 2500, twoSessions: 4000, currency: 'DA' };
  var CONTACT = window.PASSERELLE_CONTACT || {};
  var CONTACT_EMAIL = CONTACT.email || 'contact@lapasserelle-academy.com';
  var CONTACT_WHATSAPP = CONTACT.whatsapp || '213557451592';

  // state
  var state = { levelKey: CATALOG.levels[0] ? CATALOG.levels[0].key : null, classeKey: null, matiere: null };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var GROUPES = window.SOUTIEN_GROUPES || {};

  function findLevel(key) { return CATALOG.levels.filter(function (l) { return l.key === key; })[0]; }
  function findClasse(level, key) { return level ? level.classes.filter(function (c) { return c.key === key; })[0] : null; }
  function teachersFor(levelKey, classeKey, matiereFr) {
    return (CATALOG.teachers || []).filter(function (t) {
      return t.level === levelKey && t.classe === classeKey && t.matiere === matiereFr;
    });
  }
  // Tarif { one, two? } pour un niveau/matière donné, ou null si pas encore fixé (lycée uniquement).
  function tarifFor(levelKey, classeKey, matiereFr) { if (levelKey === 'primaire') return TARIFS.primaire || null; if (levelKey === 'moyen') return (classeKey === '4am' ? TARIFS.moyenBEM : TARIFS.moyen) || null; if (levelKey === 'lycee') { if (classeKey === '3as') return (TARIFS.bacSubjects || {})[matiereFr] || null; return TARIFS.lycee1_2 || null; } return null; }
  function renderTabs() {
    tabsEl.innerHTML = CATALOG.levels.map(function (l) {
      var active = l.key === state.levelKey ? ' active' : '';
      return '<button type="button" class="lvl-tab' + active + '" data-level="' + esc(l.key) + '">' +
        esc(l.fr) + '<span class="ar">' + esc(l.ar) + '</span></button>';
    }).join('');
    var max = GROUPES[state.levelKey];
    var groupEl = document.getElementById('soutienGroupe');
    if (groupEl) {
      groupEl.innerHTML = max
        ? 'Groupe spécial — ' + max + ' élèves maximum <span class="ar">مجموعة خاصة — ' + max + ' تلاميذ كحد أقصى</span>'
        : '';
    }
  }

  function renderCrumb() {
    var level = findLevel(state.levelKey);
    var parts = [];
    parts.push(state.classeKey || state.matiere
      ? '<button type="button" data-nav="level">' + esc(level ? level.fr : '') + '</button>'
      : '<span class="current">' + esc(level ? level.fr : '') + '</span>');
    if (state.classeKey) {
      var classe = findClasse(level, state.classeKey);
      parts.push('<span class="sep">›</span>');
      parts.push(state.matiere
        ? '<button type="button" data-nav="classe">' + esc(classe ? classe.fr : '') + '</button>'
        : '<span class="current">' + esc(classe ? classe.fr : '') + '</span>');
    }
    if (state.matiere) {
      parts.push('<span class="sep">›</span>');
      parts.push('<span class="current">' + esc(state.matiere.fr) + '</span>');
    }
    crumbEl.innerHTML = parts.join(' ');
  }

  function ctaHref(kind, extra) {
    var level = findLevel(state.levelKey);
    var classe = findClasse(level, state.classeKey);
    var lines = [
      'Demande de professeur — Soutien scolaire',
      'Niveau : ' + (level ? level.fr : ''),
      'Classe : ' + (classe ? classe.fr : ''),
      'Matière : ' + (state.matiere ? state.matiere.fr : ''),
    ];
    if (extra) lines.push(extra);
    var text = lines.join('\n');
    if (kind === 'whatsapp') return 'https://wa.me/' + CONTACT_WHATSAPP + '?text=' + encodeURIComponent(text);
    return 'mailto:' + CONTACT_EMAIL + '?subject=' + encodeURIComponent('Demande de professeur — La Passerelle Academy') + '&body=' + encodeURIComponent(text);
  }

  function renderPanel() {
    var level = findLevel(state.levelKey);
    if (!level) { panelEl.innerHTML = ''; return; }

    // step 1: classes
    if (!state.classeKey) {
      panelEl.innerHTML = '<div class="cat-grid">' + level.classes.map(function (c) {
        return '<button type="button" class="cat-card" data-classe="' + esc(c.key) + '">' +
          '<div><div class="cc-t">' + esc(c.fr) + '<span class="ar-h">' + esc(c.ar) + '</span></div>' +
          '<div class="cc-s">' + c.subjects.length + ' matières <span class="ar">' + c.subjects.length + ' مواد</span></div></div>' +
          '<div class="cc-arrow">→</div></button>';
      }).join('') + '</div>';
      return;
    }

    var classe = findClasse(level, state.classeKey);

    // step 2: subjects
    if (!state.matiere) {
      panelEl.innerHTML = '<div class="cat-grid">' + (classe ? classe.subjects : []).map(function (s) {
        return '<button type="button" class="cat-card" data-matiere="' + esc(s.fr) + '">' +
          '<div><div class="cc-t">' + esc(s.fr) + '<span class="ar-h">' + esc(s.ar) + '</span></div></div>' +
          '<div class="cc-arrow">→</div></button>';
      }).join('') + '</div>';
      return;
    }

    // step 3: teachers (or empty state with indicative tarifs)
    var teachers = teachersFor(state.levelKey, state.classeKey, state.matiere.fr);
      var tarif = tarifFor(state.levelKey, state.classeKey, state.matiere.fr);    if (teachers.length) {
      panelEl.innerHTML = teachers.map(function (t) {
        var amt = tarif ? (t.sessions === 1 ? tarif.one : (tarif.two || tarif.one)) : null;
        return '<div class="teach-card">' +
          '<div><div class="td-days">' + esc(t.jours) + '</div>' +
          '<div class="td-time">' + esc(t.horaire) + '</div>' +
          (t.nom ? '<div class="td-tag">' + esc(t.nom) + '</div>' : '') + '</div>' +
          '<div class="td-price">' + (amt != null
            ? '<div class="amt">' + amt + ' ' + esc(TARIFS.currency) + '</div><div class="per">par mois</div>'
            : '<div class="amt amt-sur-demande">Tarif sur demande<span class="ar">السعر عند الطلب</span></div>') +
          '</div>' +
          '<a class="btn btn-gold" href="' + ctaHref('whatsapp', t.nom ? ('Professeur souhaité : ' + t.nom) : null) + '" target="_blank" rel="noopener">S\'inscrire<span class="ar">التسجيل</span></a>' +
          '</div>';
      }).join('');
    } else if (tarif) {
      panelEl.innerHTML =
        '<div class="teach-empty">' +
        "Aucun professeur assigné pour l'instant sur ce créneau — contactez-nous, nous vous mettons en relation rapidement." +
        '<span class="ar">لا يوجد أستاذ مخصص حاليًا لهذا التوقيت — تواصلوا معنا وسنقوم بربطكم بأستاذ في أقرب وقت.</span>' +
        '<div class="teach-tarifs">' +
        '<div class="teach-tarif-pill">1 cours / semaine — ' + tarif.one + ' ' + esc(TARIFS.currency) + ' / mois</div>' +
        (tarif.two ? '<div class="teach-tarif-pill">2 cours / semaine — ' + tarif.two + ' ' + esc(TARIFS.currency) + ' / mois</div>' : '') +
        '</div>' +
        '<div class="insc-actions" style="justify-content:center;margin-top:18px;">' +
        '<a class="btn btn-gold" href="' + ctaHref('whatsapp') + '" target="_blank" rel="noopener">Être mis en relation<span class="ar">اطلب التواصل</span></a>' +
        '<a class="btn" style="border-color:var(--border);color:var(--navy-ink);background:var(--surface);" href="' + ctaHref('email') + '">Par e-mail<span class="ar" style="color:var(--soft);">عبر البريد</span></a>' +
        '</div></div>';
    } else {
      panelEl.innerHTML =
        '<div class="teach-empty">' +
        "Tarif sur demande pour cette matière — contactez-nous, nous vous répondons rapidement." +
        '<span class="ar">السعر عند الطلب لهذه المادة — تواصلوا معنا وسنجيبكم في أقرب وقت.</span>' +
        '<div class="insc-actions" style="justify-content:center;margin-top:18px;">' +
        '<a class="btn btn-gold" href="' + ctaHref('whatsapp') + '" target="_blank" rel="noopener">Demander le tarif<span class="ar">اطلب السعر</span></a>' +
        '<a class="btn" style="border-color:var(--border);color:var(--navy-ink);background:var(--surface);" href="' + ctaHref('email') + '">Par e-mail<span class="ar" style="color:var(--soft);">عبر البريد</span></a>' +
        '</div></div>';
    }
  }

  function render() { renderTabs(); renderCrumb(); renderPanel(); }

  tabsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-level]');
    if (!btn) return;
    state.levelKey = btn.getAttribute('data-level');
    state.classeKey = null; state.matiere = null;
    render();
  });
  crumbEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nav]');
    if (!btn) return;
    var nav = btn.getAttribute('data-nav');
    if (nav === 'level') { state.classeKey = null; state.matiere = null; }
    if (nav === 'classe') { state.matiere = null; }
    render();
  });
  panelEl.addEventListener('click', function (e) {
    var classeBtn = e.target.closest('[data-classe]');
    if (classeBtn) { state.classeKey = classeBtn.getAttribute('data-classe'); render(); return; }
    var matBtn = e.target.closest('[data-matiere]');
    if (matBtn) {
      var level = findLevel(state.levelKey);
      var classe = findClasse(level, state.classeKey);
      var fr = matBtn.getAttribute('data-matiere');
      state.matiere = (classe.subjects.filter(function (s) { return s.fr === fr; })[0]) || { fr: fr, ar: '' };
      render();
    }
  });

  render();
})();
